export default {
  "DotLoader": "_DotLoader_1tjkj_1",
  "Dot": "_Dot_1tjkj_1",
  "pulse": "_pulse_1tjkj_1"
};import "ni:sha-256;EDOl1jAAvYUw5XmLLNk6yBlgJDmuiX3RiJ7G-HC25Iw";